// PlanCard component with merged input and buttons
import { Card, Typography, theme, InputNumber, Space, Button, Grid, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import './style.css';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export const PlanCard = ({
  title,
  price,
  original_price: originalPrice,
  coins,
  popular = false,
  quantity = 0,
  onQuantityChange,
  save,
}) => {
  const { t } = useTranslation();
  const screens = useBreakpoint() || {};
  const { token } = theme.useToken();
  const { isDarkMode } = useTheme();
  const isMobile = screens?.xs;

  return (
    <Card
      bordered={false}
      className={`plan-actual-card${isMobile ? ' mobile-card' : ''}`}
      style={{
        width: '100%',
        position: 'relative',
        borderRadius: isMobile ? 0 : 20,
        overflow: 'hidden',
        backgroundColor: token.colorBgContainer,
        marginBottom: isMobile ? 10 : 0,
        transition: 'all 0.3s ease-in-out',
        border: isMobile ? `1px solid ${token.colorBorderSecondary}` : 'none',
      }}
      bodyStyle={{ padding: 0 }}
    >
      {popular && (
        <Text className="plan-popular-badge">
          {t('most_popular')}
        </Text>
      )}
      {save > 0 && popular && (
        <Text className="plan-save-badge" strong>
          {t('save')} {save}%
        </Text>
      )}

      <div className="plan-card-header">
        <Tooltip placement="top" title={title}>
          <Title level={5} className="plan-card-title" ellipsis={{ rows: 1 }} style={{
            color: token.colorText, background:
              !isDarkMode ? "linear-gradient(135deg, rgba(74, 108, 247, 0.12) 0%, rgba(74, 108, 247, 0.06) 100%)' : 'linear-gradient(135deg, rgba(74, 108, 247, 0.12) 0%, rgba(74, 108, 247, 0.06) 100%)" : 'unset'
          }}>{title}</Title>
        </Tooltip>
        <div className="plan-price-wrapper">
          <Text className="plan-original-price">{originalPrice}$</Text>
          <Text className="plan-card-price" style={{ color: token.colorPrimary, fontSize: screens.md ? '1.4rem' : '2.3rem' }}>{price}$</Text>
        </div>
      </div>

      <div className="plan-card-content" style={{ background: !isDarkMode ? 'linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(248, 250, 252, 1) 100%)' : 'unset' }}>
        <Text className="plan-card-coins" ellipsis={{ rows: 1 }} style={{ color: token.colorPrimary, marginBottom: 0 }}>
          {coins.toLocaleString()} {t('coins_2')}
        </Text>
        <Text className="plan-card-description" ellipsis={{ rows: 1 }} style={{ color: token.colorTextSecondary, marginBottom: 8 }}>
          ≈ {coins.toLocaleString()} {t('messages_2')}
        </Text>
        <Space.Compact block style={{ width: '100%', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            style={{ width: '40px', height: '32px' }}
            onClick={(e) => {
              e.stopPropagation();
              onQuantityChange(Math.max(0, quantity - 1));
            }}
            disabled={quantity === 0}
          >
            -
          </Button>
          <InputNumber
            min={0}
            precision={0}
            parser={value => value.replace(/\D/g, '')}
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Enter', 'Escape'].includes(e.key) &&
                !(e.ctrlKey || e.metaKey)
              ) {
                e.preventDefault();
              }
            }}
            value={quantity}
            onChange={onQuantityChange}
            controls={false}
            style={{
              width: '60px',
              height: '32px',
              textAlign: 'center',
            }}
            className="plan-centered-input"
          />
          <Button
            style={{ width: '40px', height: '32px' }}
            onClick={(e) => {
              e.stopPropagation();
              onQuantityChange(quantity + 1);
            }}
          >
            +
          </Button>
        </Space.Compact>
      </div>
    </Card >
  );
};